import api from '@/utils/api'

export const fetchPackages = (params) => {
  return api.get('/packages/', {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const createPackage = (obj) => {
  return api.post('/packages/', obj)
    .then(resp => {
      return (resp.data)
    })
}

export const updatePackage = (obj) => {
  return api.put(`/packages/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}

export const deletePackage = (obj) => {
  return api.delete(`/packages/${obj.id}/`, obj)
    .then(resp => {
      return (resp.data)
    })
}



// WEBPACK FOOTER //
// ./src/packages/api.js